/* Функции */
import {
  defineComponent, PropType, VNode,
} from 'vue'

/** Типы */
import { defaultProps, defaultStyles } from '@/components/VText/Types'

/* Стили */
import '@/components/VText/VTextSmall/VTextSmall.scss'

export default defineComponent({
  name: 'VTextSmall',

  props: {
    ...defaultProps({
      defaultOpacity: 0.8,
    }),

    /** Тег */
    tag: {
      type: String as PropType<string>,
      default: 'span',
    },
  },

  computed: {
    styles() {
      return {
        ...defaultStyles.call(this),
      }
    },
  },

  render(): VNode {
    const nameComponent = this.tag

    return (
      <nameComponent onClick={this.onClick} class={'text text-small'} style={this.styles}>
        {this.$slots.default?.()}
      </nameComponent>
    )
  },
})
